import { Maximize2, Mic, MicOff, Phone, PhoneOff } from 'lucide-react'
import { Button } from 'tailwind-v4/components/button'
import { cn } from 'tailwind-v4/lib/utils'
import { useCallSession } from './CallSessionProvider'

/**
 * The minimised call: a pill at the bottom centre of the screen, over
 * everything, while a call is being placed or is up and its dialog is
 * closed. Who you are talking to, how long, mute, back to the dialog, hang up.
 */
export function CallPill() {
  const s = useCallSession()
  if (!s.target || s.dialogOpen || !s.busy) return null
  return (
    <div className="new-ui-theme pointer-events-none fixed inset-x-0 bottom-4 z-[70] flex justify-center px-4 print:hidden">
      <div role="status" className="pointer-events-auto flex items-center gap-2 rounded-full border border-border bg-background/95 py-1.5 pl-3 pr-1.5 text-sm shadow-none backdrop-blur-none">
        <span className={cn('flex size-6 items-center justify-center rounded-full', s.live ? 'bg-success/20 text-success' : 'bg-warning/20 text-warning')}>
          <Phone className={cn('size-3.5', s.live && 'animate-pulse')} />
        </span>
        <button type="button" className="flex min-w-0 flex-col items-start leading-tight" onClick={s.showDialog} title="Open the call">
          <span className="max-w-[14rem] truncate font-medium">{s.target.enquiry.name}</span>
          <span className="max-w-[14rem] truncate text-xs text-muted-foreground tabular-nums">{s.status ?? 'On a call'}</span>
        </button>
        {s.mode === 'browser' && s.softphoneState === 'live' ? (
          <Button variant="ghost" size="icon-sm" aria-label={s.softphone.muted ? 'Unmute' : 'Mute'} onClick={s.softphone.toggleMute}>
            {s.softphone.muted ? <MicOff /> : <Mic />}
          </Button>
        ) : null}
        <Button variant="ghost" size="icon-sm" aria-label="Open the call" onClick={s.showDialog}>
          <Maximize2 />
        </Button>
        <Button variant="destructive" size="icon-sm" aria-label="Hang up" onClick={() => void s.hangUp()} disabled={s.placing || s.hangingUp}>
          <PhoneOff />
        </Button>
      </div>
    </div>
  )
}
